import { render, staticRenderFns } from "./BetHistory.vue?vue&type=template&id=73abb372"
import script from "./BetHistory.vue?vue&type=script&lang=js"
export * from "./BetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports